<template>
  <div class="tab-container">
    <b-tabs>
      <b-tab-item label="請求" class="tab-box">
        <div style="display: flex; align-items: center; margin-bottom: 8px;">
          <button class="button is-small" @click="prevMonth">前月</button>
          <p style="margin: 0 12px;">{{year}}年 {{month}}月</p>
          <button class="button is-small" @click="nextMonth">次月</button>
          <button
          @click="$store.dispatch('auth/billingDownload')"
            class="button is-small is-primary -left-8px"
            :disabled="isNowMonth()">
            {{month}}月の請求書をダウンロードする
          </button>
          <p
            style="margin-left: 4px; color: #666;"
            v-if="isNowMonth()">
            ※請求書は翌月に発行されます。
          </p>
        </div>
        <!-- 従量課金設定の時のみ -->
        <template v-if="user.billing === 3 && payperuseInfoData">
          <h2>ご利用金額</h2>
          <table style="margin: 8px 0;" v-if="billingData&&billingTable&&partsPrice">
            <tr>
              <th>日付</th>
              <th>基本料金（円）</th>
              <th>対応単価計（円）</th>
              <th>合計（円）</th>
            </tr>
            <tr>
              <td>{{year}}年 {{month}}月</td>
              <td><b>{{comma(2980)}}</b></td>
              <td><b>{{comma(sumActionPrice())}}</b></td>
              <td><b>{{comma(sumPrice(2980, sumActionPrice()))}}</b></td>
            </tr>
          </table>
          <template v-else>
            <b-skeleton width="20%" :animated="animated"></b-skeleton>
            <b-skeleton width="40%" :animated="animated"></b-skeleton>
            <b-skeleton width="80%" :animated="animated"></b-skeleton>
            <b-skeleton :animated="animated"></b-skeleton>
            <b-skeleton width="20%" :animated="animated"></b-skeleton>
            <b-skeleton width="40%" :animated="animated"></b-skeleton>
            <b-skeleton width="80%" :animated="animated"></b-skeleton>
            <b-skeleton :animated="animated"></b-skeleton>
          </template>
          <b-collapse class="card" style="margin-top: 8px;" animation="slide" aria-id="contentIdForA11y3">
            <div
              slot="trigger"
              slot-scope="props"
              class="card-header"
              role="button"
              aria-controls="contentIdForA11y3">
              <p class="card-header-title" style="display: block; margin: 0;">
                上限設定: {{comma(user.upper_price)}}円<br>
                <template v-if="payperuseInfoData.sum_pay_per_use <= user.upper_price">
                  <span style="color: #666;">
                    クリックで設定を変更（ご利用金額: {{comma(payperuseInfoData.sum_pay_per_use)}}円）
                  </span>
                </template>
                <template v-else>
                  <span style="color: #a22;">
                    ご利用金額 ({{comma(payperuseInfoData.sum_pay_per_use)}}円) は上限設定を超えています。クリックで設定を変更してください。
                  </span>
                </template>
              </p>
              <a class="card-header-icon">
                <b-icon
                  :icon="props.open ? 'menu-down' : 'menu-up'">
                </b-icon>
              </a>
            </div>
            <div class="card-content">
              <div style="display: flex; align-items: center;">
                <select class="select" style="height: 40px; width: 200px;" v-model="user.upper_price">
                  <option
                    v-for="i in [5000, 10000, 30000, 50000]"
                    :value="i" :key="i"
                    v-if="user.upper_price <= i || payperuseInfoData.sum_pay_per_use <= i">
                    {{comma(i)}}円
                  </option>
                </select>
                <button class="button" @click="setProfileUpperPrice()">変更する</button>
              </div>
              <p>
                現在の上限設定は<b>{{comma(user.upper_price)}}円</b>になります。<br>
                上限額を超えた場合でもお支払金額は上限額分のみ請求となります。<br>
                また上限額を下回る場合、お支払金額は合計額を元に請求いたします。<br>
              </p>
            </div>
          </b-collapse>
        </template>
        <b-collapse class="card" style="margin-top: 8px;" animation="slide" aria-id="contentIdForA11y3">
          <div
            slot="trigger"
            slot-scope="props"
            class="card-header"
            role="button"
            aria-controls="contentIdForA11y3">
            <p class="card-header-title" style="display: block; margin: 0;">
              請求先設定<br>
              <span style="color: #666;">
                クリックで設定を変更
              </span>
            </p>
            <a class="card-header-icon">
              <b-icon
                :icon="props.open ? 'menu-down' : 'menu-up'">
              </b-icon>
            </a>
          </div>
          <div class="card-content">
            <p>請求先郵便番号</p>
            <div style="display: flex; align-items: center;">
              <input maxlength="3" style="width: 80px;" class="input" v-model="user.billing_postal_bfr"/>
              <span class="-right-8px -left-8px">-</span>
              <input maxlength="4" style="width: 160px;" class="input" v-model="user.billing_postal_aft"/>
            </div>
            <p>請求先住所</p>
            <div style="display: flex; align-items: center;">
              <input maxlength="255" class="input" v-model="user.billing_address"/>
            </div>
            <p>請求書宛先TO（カンマ区切りで複数設定できます。）</p>
            <div style="display: flex; align-items: center;">
              <input maxlength="255" class="input" v-model="user.billing_email_to"/>
            </div>
            <p>請求書宛先CC（カンマ区切りで複数設定できます。）</p>
            <div style="display: flex; align-items: center;">
              <input maxlength="255" class="input" v-model="user.billing_email_cc"/>
            </div>
            <p>請求書自動送付（月末にメールが自動で送付されます。）</p>
            <div style="display: flex; align-items: center;">
              <b-radio v-model="user.is_billing_auto_send"
                :native-value="true">
                自動送付する
              </b-radio>
              <b-radio v-model="user.is_billing_auto_send"
                :native-value="false">
                自動送付しない
              </b-radio>
            </div>
            <button class="button is-primary -top-8px" @click="setProfile()">変更する</button>
          </div>
        </b-collapse>
        <!-- 従量課金の時のみ -->
        <template v-if="user.billing === 3 && payperuseInfoData">
          <h2>詳細</h2>
          <table v-if="billingData&&billingTable&&partsPrice">
            <tr>
              <th>日付</th>
              <th>対応単価（円）</th>
            </tr>
            <tr v-for="(bt, idx) in billingTable" :key="idx + '-bt'">
              <td>{{idx}}</td>
              <td>{{comma(bt.actionPrice)}}</td>
            </tr>
          </table>
          <template v-else>
            <b-skeleton width="20%" :animated="animated"></b-skeleton>
            <b-skeleton width="40%" :animated="animated"></b-skeleton>
            <b-skeleton width="80%" :animated="animated"></b-skeleton>
            <b-skeleton :animated="animated"></b-skeleton>
            <b-skeleton width="20%" :animated="animated"></b-skeleton>
            <b-skeleton width="40%" :animated="animated"></b-skeleton>
            <b-skeleton width="80%" :animated="animated"></b-skeleton>
            <b-skeleton :animated="animated"></b-skeleton>
          </template>
        </template>
        <!-- 従量課金以外 -->
        <template v-else>
          <div class="card" style="margin-top: 8px;">
            <div class="card-header">
              <p class="card-header-title">
                現在のプラン
              </p>
            </div>
            <div class="card-content">
              <p style="color: #a22;">
                <b>
                  {{getPlanName(user.billing)}}
                </b>
              </p>
              <p>
                毎月 {{getPlanPrice(user.billing, user.custom_price)}} 円（税抜）
              </p>
            </div>
          </div>
        </template>
      </b-tab-item>
      <b-tab-item label="単価/従量課金月額 編集" class="tab-box" v-if="user.isAgent">
        <h2>従量課金月額</h2>
        <div style="display: flex; align-items: center;">
          <input type="number" class="input" style="width: 200px;" v-model="masterBilling.pay_per_use_plan"/>
          <button class="button">変更する</button>
        </div>
        <h2>単価編集</h2>
        <table v-if="partsPrice">
          <tr>
            <th>ロボパーツ名</th>
            <th>対応単価</th>
            <th>保存</th>
          </tr>
          <tr v-for="(p, idx) in partsPrice" :key="idx + '-pp'">
            <td>{{getPartsName(p.status)}}</td>
            <td><input class="input is-small" v-model="p.action_price"/></td>
            <td><button class="button is-primary is-small" @click="updatePartsPrice(p)">保存する</button></td>
          </tr>
        </table>
        <template v-else>
          <b-skeleton width="20%" :animated="animated"></b-skeleton>
          <b-skeleton width="40%" :animated="animated"></b-skeleton>
          <b-skeleton width="80%" :animated="animated"></b-skeleton>
          <b-skeleton :animated="animated"></b-skeleton>
          <b-skeleton width="20%" :animated="animated"></b-skeleton>
          <b-skeleton width="40%" :animated="animated"></b-skeleton>
          <b-skeleton width="80%" :animated="animated"></b-skeleton>
          <b-skeleton :animated="animated"></b-skeleton>
        </template>
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
import Tooltip from '@/components/atoms/tooltips/Tooltip'
import BigNumber from "../../../../../node_modules/bignumber.js/bignumber.mjs"
export default {
  components: {
    Tooltip
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    animated: {
      type: Boolean,
      required: true
    },
    year: {
      type: Number,
      required: true
    },
    month: {
      type: Number,
      required: true
    },
    billingData: {
      type: Array,
      required: true
    },
    masterBilling: {
      type: Object,
      required: true
    },
    partsPrice: {
      type: Array,
      required: true
    },
    payperuseInfoData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      partsName: [
        {status: 0,  name: '選択肢ありメッセージ'},
        {status: 1,  name: '応募フォーム'},
        {status: 2,  name: 'メッセージのみ'},
        {status: 3,  name: 'ロボ切替'},
        {status: 4,  name: '日程自動調整'},
        {status: 5,  name: '画像表示'},
        {status: 6,  name: '自由入力'},
        {status: 7,  name: 'ファイルアップロード'},
        {status: 8,  name: '履歴書フォーム'},
        {status: 9,  name: 'Startに戻る'},
        {status: 10, name: 'メール送付'},
        {status: 12, name: '条件で分ける'},
        {status: 13, name: 'チェック項目'},
        {status: 14, name: '動画'},
        {status: 15, name: 'プルダウン'},
        {status: 16, name: 'SMS送付'},
        {status: 17, name: 'カルーセル'},
        {status: 18, name: 'ファイルダウンロード'},
        {status: 19, name: '回答出力'},
        {status: 20, name: '検索'},
      ]
    }
  },
  computed: {
    billingTable () {
      let ret = {}
      for (const bi of this.billingData) {
        const year  = new Date(bi.fields.created_at).getFullYear()
        const month = ('00' + (new Date(bi.fields.created_at).getMonth() + 1)).slice( -2 )
        const day   = ('00' + new Date(bi.fields.created_at).getDate()).slice( -2 )
        const key = year + '-' + month + '-' + day
        const showPrice   = ret[key] ? ret[key].showPrice : 0
        const actionPrice = ret[key] ? ret[key].actionPrice : 0
        ret[key] = {
          showPrice: new BigNumber(showPrice).plus(new BigNumber(this.getShowPrice(bi.fields.status, bi.fields.bot))),
          actionPrice: new BigNumber(actionPrice).plus(new BigNumber(this.getActionPrice(bi.fields.status, bi.fields.visitor))),
        }
      }
      return this.sortTable(ret)
    }
  },
  methods: {
    isNowMonth () {
      let nowYear = new Date().getFullYear()
      let nowMonth = new Date().getMonth() + 1
      return (this.year == nowYear && this.month == nowMonth) && (!this.user.isAgent)
    },
    sortTable (table) {
      let sorted = {}
      let array = []
      for (let key in table) {
        if (table.hasOwnProperty(key)) {
          array.push(key)
        }
      }
      array.sort()
      for (let i = 0; i < array.length; i++) {
        sorted[array[i]] = table[array[i]]
      }
      return sorted
    },
    getShowPrice (status, bot) {
      if (bot) {
        for (const p of this.partsPrice) {
          if (p.status == status) {
            return p.show_price
          }
        }
      }
      return 0
    },
    getActionPrice (status, visitor) {
      if (visitor) {
        for (const p of this.partsPrice) {
          if (p.status == status) {
            return p.action_price
          }
        }
      }
      return 0
    },
    getPartsName (status) {
      for (const p of this.partsName) {
        if (p.status == status) {
          return p.name
        }
      }
      return '-'
    },
    nextMonth () {
      this.$emit('nextMonth')
    },
    prevMonth () {
      this.$emit('prevMonth')
    },
    comma (num) {
      let s = String(num).split('.')
      let ret = String(s[0]).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      if (s.length > 1) {
          ret += '.' + s[1]
      }
      return ret
    },
    sumShowPrice () {
      let sum = 0
      for (let bt in this.billingTable) {
        sum = new BigNumber(sum).plus(new BigNumber(this.billingTable[bt].showPrice))
      }
      return sum
    },
    sumActionPrice () {
      let sum = 0
      for (let bt in this.billingTable) {
        sum = new BigNumber(sum).plus(new BigNumber(this.billingTable[bt].actionPrice))
      }
      return sum
    },
    sumPrice (x, y) {
      return new BigNumber(x).plus(new BigNumber(y))
    },
    updatePartsPrice (parts) {
      this.$emit('updatePartsPrice', parts)
    },
    setProfileUpperPrice () {
      if (window.confirm('上限を変更します。この変更は即時反映されますがよろしいでしょうか？')) {
        this.$emit('setProfile', {
          upper_price: this.user.upper_price
        })
      } else {
        alert('上限設定の変更をキャンセルいたしました。')
      }
    },
    setProfile () {
      this.$emit('setProfile', {
        billing_postal_bfr: this.user.billing_postal_bfr,
        billing_postal_aft: this.user.billing_postal_aft,
        billing_address: this.user.billing_address,
        billing_email_to: this.user.billing_email_to,
        billing_email_cc: this.user.billing_email_cc,
        is_billing_auto_send: this.user.is_billing_auto_send,
      })
    },
    getPlanName (plan) {
      switch (plan) {
        case 0:
          return '無料プラン'
        case 1:
          return 'ライトプラン'
        case 2:
          return 'スタンダードプラン'
        case 3:
          return '従量課金プラン'
        case 9:
          return 'カスタムプラン'
      }
    },
    getPlanPrice (plan, price) {
      switch (plan) {
        case 0:
          return '0'
        case 1:
          return '50,000'
        case 2:
          return '200,000'
        case 3:
          return '2,980'
        case 9:
          return this.comma(price)
        default:
          return '-'
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.tab-container {
  padding: 8px;
  overflow: auto;
  height: 100%;
  text-align: left;
}
.tab-box {
  padding: 16px;
}
/deep/ .tabs > ul {
  margin-left: 0;
}
</style>


// WEBPACK FOOTER //
// src/views/DashBoard/Setting/Billing/BillingView.vue